import React, { Component } from 'react';
import { toast } from 'react-toastify';
import voca from 'voca';
import RestAPICollectionFieldsModal from '../rest-api/RestAPICollectionFieldsModal';

export default class ExternalBodyCollectionMapping extends Component {
  state = {
    mappingCollectionKey: this.props.collectionMappingRow.key,
    mappingCollectionValue: this.props.collectionMappingRow.value,
    showModalForCollectionFields: false,
  };

  toggleFieldsModal = () => {
    this.setState({ showModalForCollectionFields: !this.state.showModalForCollectionFields });
  };

  copyToClipboard = () => {
    this.setState({
      copied: true,
      showModalForCollectionFields: !this.state.showModalForCollectionFields,
    });
    toast.success('Copied to clipboard');
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  insertTextToCollectionFieldInput = (textToInsert) => {
    if (textToInsert) {
      const inputElem = document.getElementById(
        `mappingCollectionValue${this.props.collectionMappingRow.id}`,
      );
      let start = inputElem.selectionStart;
      // obtain the index of the last selected character
      let finish = inputElem.selectionEnd;
      //obtain all Text
      let allText = inputElem.value;
      // obtain the selected text
      let sel = allText.substring(start, finish);
      let newText = '';
      if (sel) {
        newText = allText.replace(sel, textToInsert);
      } else {
        newText = allText + textToInsert;
      }

      this.setState({
        showModalForCollectionFields: !this.state.showModalForCollectionFields,
        mappingCollectionValue: newText,
      });
      this.props.collectionMappingRow.value = newText;
      toast.success('Inserted into Collection Field');
    }
  };

  showCollectionFieldModal = () => {
    const { collectionName, bodyDataFrom, collections, projectDetail } = this.props;
    const selectedCollection =
      collectionName &&
      collections &&
      collections.find((collection) => {
        return collection.collectionName === collectionName;
      });

    return (
      <RestAPICollectionFieldsModal
        selectedCollection={selectedCollection}
        collections={collections}
        projectDetail={projectDetail}
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={this.insertTextToCollectionFieldInput}
        toggleFields={this.state.showModalForCollectionFields}
        toggleFieldsModal={this.toggleFieldsModal}
        bodyDataFrom={bodyDataFrom}
      />
    );
  };

  onKeyChange = (e) => {
    this.setState({
      ...this.state,
      mappingCollectionKey: voca.trim(e.target.value),
    });

    this.props.collectionMappingRow.key = voca.trim(e.target.value);
    this.props.createNewCollectionMappingRow(this.props.collectionMappingRow);
  };

  onValueChange = (e) => {
    this.setState({
      ...this.state,
      mappingCollectionValue: e.target.value,
    });
    this.props.collectionMappingRow.value = e.target.value;
    this.props.createNewCollectionMappingRow(this.props.collectionMappingRow);
  };

  render() {
    return (
      <>
        {this.state.showModalForCollectionFields && this.showCollectionFieldModal()}
        <div className="row my-2 mx-auto">
          <div className="col-md-6 col-lg-6 col-sm-6">
            <input
              type="text"
              name="mappingCollectionKey"
              value={this.state.mappingCollectionKey}
              className="form-control form-control-sm"
              onChange={this.onKeyChange}
              placeholder="Key"
            />
          </div>
          <div className="col-md-6 col-lg-6 col-sm-6">
            <div className="input-group">
              <input
                type="text"
                name="mappingCollectionValue"
                value={this.state.mappingCollectionValue}
                className="form-control form-control-sm"
                onChange={this.onValueChange}
                placeholder="Value"
                id={`mappingCollectionValue${this.props.collectionMappingRow.id}`}
              />
              <div className="input-group-append">
                <span className="input-group-text">
                  <button
                    type="button"
                    className="btn btn-theme-submit btn-xs btn-icon-only"
                    title="Add Fields"
                    onClick={() => {
                      this.toggleFieldsModal();
                    }}
                  >
                    <i className="wb webconnect-plus" />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
